// packages/services/src/dashboardService.ts
import axios from 'axios';
import { getConfig } from '../config';
import { AdminDashboardData } from '../types/Dashboard';



export const dashboardService = {
  // L'admin voit tout
  getAdminStats: async (token: string): Promise<AdminDashboardData | null> => {
    const { apiUrl } = getConfig();
    try {
      const res = await axios.get(`${apiUrl}/dashboard`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return res.data?.data || null;
    } catch (error) {
      console.error('Erreur chargement dashboard:', error);
      return null;
    }
  },
};